/**
 * AssetScanPurposeService
 * Service for AssetScanPurpose lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetScanPurpose CRUD operations */
export class AssetScanPurposeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetScanPurposeService.DEFAULT_SERVICE_PATH,
            basePath: AssetScanPurposeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetScanPurposeService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetScanPurposeService.BASE_PATH = 'api/asset-scan-purposes';
//# sourceMappingURL=AssetScanPurposeService.js.map